var npsScale = $('.scale-button')

npsScale.hover(function () {
    var $this = $(this);
    var $prevAll = $(this).prevAll();

    var className = $this.attr("name") + "-hover";

    $this.addClass(className);
    $prevAll.addClass(className);
}, function () {
    var $this = $(this);
    var $prevAll = $(this).prevAll();

    $this.removeClass("detractor-hover passive-hover promoter-hover");
    $prevAll.removeClass("detractor-hover passive-hover promoter-hover");
})

npsScale.click(function () {
    var $this = $(this);
    var $prevAll = $(this).prevAll();
    var $nextAll = $(this).nextAll();
    var className = $this.attr("name") + "-clicked";
    $this.removeClass("detractor-clicked passive-clicked promoter-clicked");
    $prevAll.removeClass("detractor-clicked passive-clicked promoter-clicked");
    $this.addClass(className);
    $prevAll.addClass(className);
    $nextAll.removeClass("detractor-clicked passive-clicked promoter-clicked");


    var inputName = $this.children().attr("name").substring(11, 12);
    $('.score-error-' + inputName).css("display", "none");
})

$("[id^=nextButton]").click(function () {
    var indicator = this.id.slice(-1);
    var result = getScoreError(indicator)
    var score = result[0];
    var scoreError = result[1];
    if (score === undefined) {
        if (scoreError.css("display") === "none") {
            scoreError.css("display", "block");
        }
        return;
    }
    $("#myCarousel").carousel("next");
});

$('#npsForm').submit(function (event) {
    event.preventDefault();
    var $form = $(event.target);
    var indicator = $("[id^=submitButton]").attr('id').slice(-1);
    var result = getScoreError(indicator)
    var score = result[0];
    var scoreError = result[1];
    if (score === undefined) {
        if (scoreError.css("display") === "none") {
            scoreError.css("display", "block");
        }
        return;
    }
    $.ajax({
        type: 'POST',
        url: '/submitNps',
        data: $form.serialize(),
        success: function () {
            $("#myCarousel").carousel("next");
            $(".carousel-indicators").css("display", "none")
        }
    })
});

function getScoreError(indicator) {
    var inputName = "npsAnswers[" + indicator + "].score";
    var score = $("input[name='" + inputName + "']:checked").val();
    var scoreError = $('.score-error-' + indicator);
    return [score, scoreError];
}
